"use client";

import posthog from "posthog-js";

export function initPostHog() {
  if (typeof window !== "undefined" && process.env.NEXT_PUBLIC_POSTHOG_KEY) {
    posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
      api_host: "/p",
      ui_host: "https://eu.posthog.com",
      capture_pageview: true,
      capture_pageleave: true,
    });
  }
}

export { posthog };
